<template>
  <div class="video-gallery">
    <main-video v-if="videoId" :video-id="videoId"></main-video>
    <video-slider :videos="videos"></video-slider>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import MainVideo from './MainVideo'
import VideoSlider from './VideoSlider'

export default {
  name: 'VideoGallery',
  components: {
    VideoSlider,
    MainVideo
  },
  props: {
    videos: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState({
      videoId: state => state.videoGallery.currentVideoInfo.video_id
    })
  },
  methods: {
    ...mapActions(['CHANGE_CURRENT_VIDEO_INFO'])
  },
  mounted () {
    this.CHANGE_CURRENT_VIDEO_INFO(this.videos[0])
  }
}
</script>

<style scoped lang="sass">

</style>
